import { Card as VCard } from '@uma/react-commons/dist/index';
import tokens from '@veneer/tokens';
import { MainTheme } from '@uma/react-commons/dist';
import styled from 'styled-components';

export const ClickableLabel = styled.a`
  min-width: 324px;
  width: 50%;
  cursor: pointer;
  text-decoration: none;
  border-radius: ${tokens.layout.size2};
  outline: none;
  border: 1px solid ${tokens.color.gray3};
  box-sizing: border-box;
  transition:
    background-color 0.15s,
    border-color 0.1s,
    outline-color 0.1s;

  &:hover {
    text-decoration: none;
    background-color: ${tokens.color.gray1};
  }

  &:focus-visible {
    outline: 2px solid #001cb0;
    outline-offset: -1px;
  }

  > div {
    padding: 0;
    border-radius: ${tokens.layout.size2} !important;
    border: none;
  }
`;

export const Link = styled.p`
  color: #024ad8;
`;

export const Card = styled(VCard)`
  & {
    display: flex !important;
    flex-direction: column;
    height: 100%;
  }

  label {
    cursor: pointer;
  }

  div:nth-child(2) {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0px;
    height: 100%;

    div > div {
      padding: 0px 16px;
      min-height: 24px;
    }

    div:nth-child(2) {
      display: flex;
      min-height: 24px;
      justify-content: flex-end;
      margin-bottom: 8px;
    }

    div:nth-child(3) {
      display: none;
    }
  }

  &:hover {
    background-color: ${tokens.color.gray1};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: stretch;

  @media (max-width: ${MainTheme.breakpoints.mdMax}) {
    flex-direction: column;
    align-items: center;
  }
`;
